/* FAQ copy corrections, applied over the answers ice-freaks.js renders.
   - Fleece lining is confirmed, so the helmet and warmth answers no longer
     say "not fleece", and the materials answer mentions it.
   - Returns: not "no questions asked". We want to hear how the mask landed
     before a return, so the answer asks for that, warmly. */
(function(){
var A={
'does it actually fit under a helmet?':'Yes. The outer is a thin four-way stretch knit and the fleece lining is soft and low-profile, so there is no bulk at the crown. Goggles sit straight over the eye openings.',
'is it warm enough for a real cold day?':'Yes. The fleece lining traps heat against your face and the mask seals the neck gap, so it stays warm on the lift and on the way down.',
'what is it made of?':'A breathable four-way stretch poly-spandex outer with a soft fleece lining inside. The print is dyed into the fabric, so it does not crack, peel, or fade in the wash.',
'what is your return policy?':'You have 14 days from delivery. Just email us and tell us how the mask felt and whether it met your expectations. We read every message, because we want everyone to love their mask, and we will sort out a return or an exchange for another face.'
};
function run(){
var fw=document.getElementById('if-faqs');
if(!fw)return;
var items=fw.children;
for(var i=0;i<items.length;i++){
var b=items[i].querySelector('button');
var p=items[i].querySelector('p');
if(!b||!p)continue;
var q=(b.querySelector('span')||b).textContent.trim().toLowerCase();
if(A[q]&&p.textContent!==A[q])p.textContent=A[q];
}
}
var n=0;
var iv=setInterval(function(){n++;run();if(n>40)clearInterval(iv);},250);
setInterval(run,1500);
if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
